import React from "react";
import useStyles from "./styles";
import clsx from "clsx";

export interface Props {
  children?: React.ReactNode;
  className?: string;
}

const AppPage = (props: Props) => {
  const { children, className } = props;
  const classes = useStyles();

  return <div className={clsx(classes.appPageRoot, className)}>{children}</div>;
};

export default AppPage;
